<template>
    <div class="st-main-content">
        <div class="query-setting-box">
            <div class="query-setting-box-left">
                <div class="order-query-form-box">
                    <label for="start-date">员工姓名：</label>
                    <span class="order-query-form-input"><input type="text" v-model="orderForm.name"  ></span>
                </div>
                <div class="order-query-form-box">
                    <label for="start-date">员工手机号码：</label>
                    <span class="order-query-form-input"><input type="number" v-model="orderForm.phone"  ></span>
                </div>
               
				<div class="order-query-form-box">
				    <label for="start-date">身份证号码：</label>
				    <span class="order-query-form-input"><input type="number" v-model="orderForm.card"  ></span>
				</div>
                <div class="order-query-form-box">
                    <label for="start-date">员工归属：</label>
                    <span class="order-query-form-input">
						<el-cascader :options="options"  ref="cascaderAddr"  @change="handleAreaChange" :props="defaultParams" v-model="orderForm.departmentId"   class="stSetSelect"></el-cascader>
                       <!-- <el-select v-model="orderForm.userType" placeholder="请选择" class="stSetSelect">
                            <el-option v-for="item in userStatusList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select> -->
                    </span>
                </div>
            </div>
            <div class="order-query-form-box-right">
                <span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
            </div>
			<div class="order-query-form-box-right">
			    <span class="order-query-form-submit stPointer" @click="CreateUser">新建</span>
			</div>
        </div>
        <div class="data-table-box">
            <common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
                :loading="loading"
				:showPage="togglePage"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
        </div>
      <div class="previewImg" v-if="toggleImg">
      	<img @click="toggleImg=false" class="closeImg" src="../../assets/images/close.png" alt="">
      	<div class="previewImgWarp">
      		<div class="mypreviewImg">
      			<img :src="previewPath" >
      		</div>
      	</div>
      </div>
		<!-- //编辑模块 -->
		<st-dialog title="编辑员工信息" :toggleStDialog="toggleStEditDialog"   @closeDialog="closeEditForm" @saveDialog="saveEditForm" :setScrollTop="true">
					<div class="st-dialog-content" >
						<ul class="st-dialog-form clearfix">
							<li>
								<div class="st-dialog-item-title"><i>*</i>员工姓名：</div>
								<div class="st-dialog-item-input"><input type="text" v-model="userInfo.name"></div>
							</li>
							<li>
								<div class="st-dialog-item-title"><i>*</i>员工电话：</div>
								<div class="st-dialog-item-input"><input type="number"  v-model="userInfo.phone" ></div>
							</li>
							<li>
								<div class="st-dialog-item-title"><i>*</i>员工性别：</div>
								<el-select v-model="userInfo.gender" placeholder="请选择" class="stSetSelect">
								     <el-option v-for="item in genterList" :key="item.value" :label="item.name"
								         :value="item.value">
								     </el-option>
								 </el-select>
								
							</li>
							<li>
								<div class="st-dialog-item-title"><i>*</i>身份证号码：</div>
								<div class="st-dialog-item-input"><input type="text" v-model="userInfo.card" @blur="changeInput('card')" ></div>
							</li>
							<li>
								<div class="st-dialog-item-title"><i>*</i>职位：</div>
								<el-select v-model="userInfo.positionId" placeholder="请选择" class="stSetSelect">
								     <el-option v-for="item in positionList" :key="item.id" :label="item.showText"
								         :value="item.id">
								     </el-option>
								 </el-select>
							</li>
							<li>
								<div class="st-dialog-item-title"><i>*</i>所属部门：</div>
								<el-select v-model="userInfo.departmentId" placeholder="请选择" class="stSetSelect">
								     <el-option v-for="item in departmentList" :key="item.id" :label="item.name"
								         :value="item.id">
								     </el-option>
								 </el-select>
							</li>
							<li>
								<div class="st-dialog-item-title"><i>*</i>地址：</div>
								<div class="st-dialog-item-input"><input type="text"  v-model="userInfo.address"></div>
							</li>
						</ul>
					</div>
				</st-dialog>
	</div>
</template>
<script>
import stDialog from '../../components/StDialog'
    export default {
        name: 'SalesmanMaterial',
        props: [],
		components: { stDialog },
        data() {
            return {
			 defaultParams: {
				 label: 'name',
				 value: 'id',
				 children: 'salemaneList',
				 checkStrictly: true
				 },
				editmaninfo:false,
				toggleStDialog:false,
				toggleStEditDialog:false,
                tableColumns:[
					{
						title: '选择',
						type: 'selection',
						fixed: 'left',
					},
                    {key: 'name',title: '员工姓名' },
					{key: 'genders',title: '性别'},
                    {key:'salemanDepartmentname',title: '所属部门'},
                    {key: 'phone',title: '联系方式'},
                    {key: 'address',title: '地址'},
                    {key: 'card',title: '身份证号码'},
					{key: 'position',title: '职位'},
                   {
                   	key: '',
                   	title: '操作',
                   	operate:true,
                   	align:'center',
                   	width: '150',
                   	setBtns:(row,index)=>{
                   		return [
                   			{
                   				label:'编辑',
                   				handler: (row,index) => this.editUser(row)
                   			},
                   			{ 
                   				label:'删除',
                   				handler: (row,index) => this.cancelContract(row)
                   			},
						
                   		
                   		]
                   	}
                   },
                ],
				options: [],
				checkData:{//编辑的数据
					name:'员工姓名不可为空',
					card:'身份证号不可为空',
					gender:'性别不可为空',
					phone:'电话不可为空',
					address:'地址不可为空',
					positionId:'职位不可为空',
					departmentId:'部门不能为空'
				},
                pageConfig: {
                    total: 0,
                    pageSize: 50,
                    currentPage: 1,
                },
                bottomHandleArr:[
                    // {
                    //     label: '审核',
                    //     handler: () => this.setAudit()
                    // },
                    {
                        label: '导出',
                        handler: () => this.exportTable()
                    },
                ],
                loading:false,
                showPage:false,
                toggleImg: false,
                previewPath: null,
                dataList: [], //订单列表
				userInfo:{},//保存信息
                orderForm: {
					card:'',
                    current: 1, 
                    departmentId:null, 
                    id:null,
					name:'',
					phone:'',
					size:null,
                },
				cascaderAddr:[],//获取部门筛选数据
				updetaflag:0,
                togglePage: false, //是否显示分页
				positionList:[],//职位列表
				departmentList:[],
                userStatusList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '货主'
                    },
                    {
                        value: 2,
                        label: '司机'
                    }
                ],
				genterList:[
					{value:'1',name:'男'},
					{value:'2',name:'女'},
				],

            }
        },
        created() { },
	
        methods: {
			//获取部门筛选数据
			handleAreaChange(val){
			      this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels
			      console.log(this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels)
				  this.cascaderAddr = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels
			 },
			
			//输入框校验
			changeInput(key){
				if(!this.userInfo[key]) return;
					if(key==='card'){
					let reg=/^[0-9][0-9]{16}[0-9|x]$/i
					if(!reg.test(this.userInfo[key])){
						this.$toast.stMessage('身份证号格式不正确', false)
					}
				}
			},
			//删除
			cancelContract(row){
			console.log(row)
			this.$server.material.salemandelate(row.id, (res) => {
			    if (res.code == 0) {
				this.$toast.stMessage('删除成功', true)
				this.searchList()
			    }
			})
		
			},
		
            sizeChange(size) {
                this.pageConfig.currentPage = 1
                this.pageConfig.pageSize = size
                this.searchList()
            },
            currentChange(currentPage) {
                this.pageConfig.currentPage = currentPage
                this.searchList()
            },
            exportTable() {
                let that = this;
				if (this.dataList.length < 1) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
			    pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.tableColumns.map((item) =>{
						return item.key
					}).filter(item => {
						return item && item.trim()
					})
				}
				sendData.beginTime = sendData.beginTime ? new Date(sendData.beginTime).getTime() : ''
				sendData.endTime = sendData.endTime ? new Date(sendData.endTime).getTime() : ''
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/appuser/c',sendData, (res) => {
					console.log('导出成功')
				})
            },
            argImg(src) {
                this.previewPath = src;
                this.toggleImg = true;
            },
			//保存信息
			saveEditForm(){
				console.log(this.updetaflag)
				if(this.updetaflag == 0){
					console.log(this.userInfo)
					let userInfo = this.userInfo
					userInfo.state = '1'
					if(userInfo.gender == '女'){
						userInfo.gender = '2'
					}else{
						userInfo.gender = '1'
					}
					for(var key in this.checkData){
						if(!this.userInfo[key]){
							this.$toast.stMessage(this.checkData[key], false)
							return;
						}
					}
					this.$server.material.salemanadd(userInfo,(res)=>{
						if(res.code==0){
							this.$toast.stMessage('添加成功', true)
							this.searchList()
							this.toggleStEditDialog=false;
						}
					})
				}else if(this.updetaflag == 1){
					this.update()
				}
			
			},
			//编辑员工资料
			editUser(row) {
				console.log(this.userInfo)
				this.userInfo=JSON.parse(JSON.stringify(row));
				this.toggleStEditDialog=true
				this.updetaflag = 1 //判断是新增还是修改
				if(this.userInfo.gender == '2'){
					this.userInfo.gender = '女'
				}else{
					this.userInfo.gender = '男'
				}
			},
			update(){
				console.log(this.userInfo)
				let userInfo = this.userInfo
				userInfo.state = '1'
				if(userInfo.gender == '女'){
					userInfo.gender = '2'
				}else{
					userInfo.gender = '1'
				}
				for(var key in this.checkData){
					if(!this.userInfo[key]){
						this.$toast.stMessage(this.checkData[key], false)
						return;
					}
				}
				this.$server.material.salemanupdate(userInfo,(res)=>{
					if(res.code==0){
						this.$toast.stMessage('修改成功', true)
						this.searchList()
						this.toggleStEditDialog=false;
					}
				})
			},
			closeEditForm(){
				this.toggleStEditDialog=false
			},
            searchList(flag) {
                let pages = {};
                pages.size = this.pageConfig.pageSize;
                pages.current = this.pageConfig.currentPage;
                if(flag) pages.current = 1;
                let orderForm = this.orderForm;
                this.loading=true;
                Object.assign(orderForm, pages)
                this.getData(orderForm)
            },
			CreateUser(){
				this.toggleStEditDialog=true;
				this.userInfo = {};
				this.updetaflag = 0
			},
            getData(data) {
			
				if(this.cascaderAddr.length == 1){
					data.departmentId = data.departmentId[0]
				}else{
					if(typeof(this.$refs['cascaderAddr'].getCheckedNodes()[0]) != 'undefined'){
						 data.name = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels[1]
					}
					
					data.departmentId = null
				}
                this.$server.material.list(data, (res) => {
                    this.loading=false;
                    if (res.code == 0) {
						for( var i =0 ; i < res.data.records.length;i++){
							res.data.records[i].salemanDepartmentname = res.data.records[i].salemanDepartment.name;
							if(res.data.records[i].gender == 1){
								res.data.records[i].genders ='男' 
							}else{
								res.data.records[i].genders ='女' 
							}
							  this.dataList = res.data.records;
						}
						
                       this.pageConfig.total = res.data.total;
					    this.pageConfig.currentPage = res.data.current;
                        if (res.data.total > 0) {
                            this.togglePage = true;
                        }
						console.log(res.data.records)
                    }
                })
				
            },
         
            selectionChange(row) {
                this.selectedList = row;
            },
            cellClass(row) {
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
        },
        mounted() {

		this.$server.material.querySaleman((res)=>{
			console.log(res)
			this.options = res.data
			console.log(this.options)
			})
			this.$server.material.dictionarydetail((res)=>{
				console.log(res)
				this.positionList = res.data
				})
				this.$server.material.salemandepartment((res)=>{
					console.log(res)
					this.departmentList = res.data
					})
			
        }
    }

</script>
<style scoped>
.st-dialog-content{
	padding: 0 32px;
}
.st-dialog-form{
	width: 406px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
.st-dialog-form li {
	width: 156px;
	padding: 13px 0;
}
.st-dialog-form li:nth-child(even){
	float: right;
}
.st-dialog-form li:nth-child(odd){
	float: left;
}
.st-dialog-form .st-dialog-item-title{
	height: 20px;
	line-height: 20px;
}
.st-dialog-form .st-dialog-item-title i{
	color: #FF5B3E;
}
.st-dialog-form .st-dialog-item-input input{ 
	width: 156px;
	height: 30px;
	text-indent: 8px;
	border-radius: 2px;
	border: 1px solid #DCDCDC;
	box-sizing: border-box;
}
  .st-main-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .data-table-box {
        height: auto;
        background: #FFF;
        padding: 8px;
        box-sizing: border-box;
    }

    .data-table {
        margin-bottom: 8px;
    }

    .query-setting-box-left {
        flex-grow: 0;
    }

    .previewImg {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, .5);
        z-index: 99;
    }
.el-cascader{
	top:-5px
}
.el-input__suffix-inner{
 display: block;
      margin-top: -3px;
}
.order-query-form-box-right{
	    margin-right: 100px;
}
    .previewImgWarp {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -300px;
        margin-top: -300px;
        width: 600px;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mypreviewImg {
        display: inline-block;
        border: 5px solid #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .mypreviewImg img {
        max-width: 600px;
    }

    .closeImg {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
</style>